<template>
  <div class="commercial-print-index">
    <app-view-layout
      header="Akcydensy NBP"
      fluid
      no-padding
    >
      <template #toolbarMenu>
        <CPToolbarMenu />
      </template>
      <template #content>
        <v-card>
          <div class="py-0 px-8">
            <v-tabs v-model="tab">
              <v-tab
                v-for="value in options"
                :key="value.label"
                :href="`#${value.label}`"
                @click="filterCommercialPrint({ statuses: value.statuses })"
              >
                {{ value.tab }}
              </v-tab>
            </v-tabs>
          </div>
        </v-card>
        <div class="pt-8 pb-4 px-8">
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="value in options"
              :key="value.label"
              :value="value.label"
              flat
            >
              <v-card
                class="py-6 px-8"
                flat
                tile
              >
                <CPTable
                  v-if="tab === value.label"
                  :header="value.title"
                  :commercial-print-list="commercialPrintList"
                  :label="value.label"
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>

          <AppPagination
            v-if="commercialPrintList.length"
            @change="changePage"
          />
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppPagination from '@/components/UI/AppPagination.vue';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import CPTable from '@/components/CommercialPrint/CPTable.vue';
import CPToolbarMenu from '@/components/CommercialPrint/CPToolbarMenu.vue';

export default {
  components: {
    AppPagination,
    CPTable,
    AppViewLayout,
    CPToolbarMenu,
  },

  data() {
    return {
      tab: '',
      options: [
        {
          label: 'pending',
          statuses: ['Zespół projektowy skompletowany'],
          title: 'Do podjęcia',
          tab: 'Lista wniosków do podjęcia',
        },
        {
          label: 'workInProgress',
          statuses: ['Zespół projektowy pracuje nad projektem'],
          title: 'W realizacji',
          tab: 'Wniosek w realizacji',
        },
        {
          label: 'rejected',
          statuses: ['Odrzucony przez Dyrekcję', 'Odrzucony przez Naczelnika WM', 'Odrzucony przez wnioskodawcę', 'Grafik poprosił o zmiany'],
          title: 'Odrzucony',
          tab: 'Wniosek odrzucony',
        },
        {
          label: 'creatorReview',
          statuses: ['Do akceptacji wnioskodawcy'],
          title: 'Akceptacja wnioskodawcy',
          tab: 'Akceptacja wnioskodawcy',
        },
        {
          label: 'printCoordinatorReview',
          statuses: ['Do akceptacji Koordynatora druku'],
          title: 'Akceptacja Koordynatora druku',
          tab: 'Akceptacja Koordynatora druku',
        },
        {
          label: 'adminReview',
          statuses: ['Do akceptacji Dyrekcji DKO'],
          title: 'Akceptacja Dyrekcji DKO',
          tab: 'Akceptacja Dyrekcji DKO',
        },
        {
          label: 'archived',
          statuses: ['Zaakceptowany i zarchiwizowany'],
          title: 'Zarchiwizowany',
          tab: 'Zarchiwizowany',
        },
      ],
    };
  },

  computed: {
    ...mapState('commercialPrint', ['commercialPrintList']),
  },

  created() {
    this.filterCommercialPrint({ statuses: this.options[0].statuses });
  },

  beforeDestroy() {
    this.resetCommercialPrint();
  },

  methods: {
    ...mapActions('commercialPrint', ['fetchCommercialPrint', 'resetCommercialPrint']),

    ...mapActions('filters', ['setFilters']),

    changePage() {
      this.fetchCommercialPrint();
    },

    filterCommercialPrint(filter) {
      this.setFilters(filter).then(() => {
        this.fetchCommercialPrint();
      });
    },
  },
};
</script>
